// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jz-0";
export var animationContainer = "_jz-1";
export var itemPrice = "_jz-a";
export var itemizedContent = "_jz-9";
export var itemizedHeader = "_jz-7";
export var itemizedRow = "_jz-8";
export var itemizedSection = "_jz-6";
export var modalContent = "_jz-2";
export var orderName = "_jz-3";
export var refundOption = "_jz-4";
export var refundOptionsContainer = "_jz-5";
export var shippingLabel = "_jz-b";
export var totalRow = "_jz-c";